const TokenKey = 'token'

export function getToken () {
  return sessionStorage.getItem(TokenKey)
}

export function setToken (token) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken () {
  return sessionStorage.removeItem(TokenKey)
}

/**
 * 从 JWT token 的 payload 中解析 openId
 * 后端将 wechat_open_id 放在 token payload 里，登录响应体里没有 openId 字段
 */
export function parseOpenIdFromToken (token) {
  if (!token) return ''
  try {
    const payload = token.split('.')[1]
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const decoded = JSON.parse(decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join('')))
    return decoded.wechat_open_id || decoded.wechatProgramOpenId || ''
  } catch (e) {
    console.error('解析 token 获取 openId 失败:', e)
    return ''
  }
}
